import Asset from "./components/Asset";
import Message from "./components/Message";
import ExerciseRegistry from "./components/ExerciseRegistry";

import "./styles.scss";

export default function PublishPostView({
    configRef,
    communityRef,
    exerciseRegistry,
    onExerciseRegistryChange,
    onUploadBusyChange,
}) {
    const communityId = communityRef.current?.id
        ? parseInt(communityRef.current.id)
        : null;

    return (
        <div className="publish-post-modal px-4 py-1">
            <Asset
                configRef={configRef}
                communityId={communityId}
                onUploadingChange={onUploadBusyChange}
            />
            <Message configRef={configRef} />
            <ExerciseRegistry
                configRef={configRef}
                enabled={exerciseRegistry}
                onEnabledChange={onExerciseRegistryChange}
            />
        </div>
    );
}
